import { defineStore } from 'pinia'
import { useLocalStorage, useSessionStorage } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { computed, nextTick, ref, watch } from 'vue'
import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
export const useUserStore = defineStore('userStore', () => {
  const { authGet } = useHallApi()
  const _initData: IUserInfoReply = {
    id: '',
    agentId: '',
    username: '',
    status: AgentUserStatus.None,
    passwordStatus: AgentUserPasswordStatus.None,
    agentInfo: {
      id: '',
      name: '',
      domain: '',
      channel: '',
      status: AgentStatus.None
    }
  }
  const userInfo = useLocalStorage('__K_USERINFO', _initData)
  const nickname = computed(() => userInfo.value?.agentInfo?.name)
  const agentDomain = computed(()=>userInfo.value?.agentInfo?.domain)
  const needChangePassword = computed(
    () =>
      userInfo.value?.passwordStatus === AgentUserPasswordStatus.Init ||
      userInfo.value?.passwordStatus === AgentUserPasswordStatus.Reset
  )

  const reqUserInfo = async () => {
    const r = await authGet<IUserInfoReply>(
      AgentApiPath.UserInfo,
      {},
      {
        showErrorCodeTip: true,
        showLoading: true
      }
    )

    if (r.isSuccess) {
      userInfo.value = r.data
    }
  }
  const reset = () => {
    userInfo.value = _initData
  }
  return { reset, reqUserInfo, nickname, needChangePassword, agentDomain }
})

export enum AgentStatus {
  None = 0,
  Normal = 1,
  Banned = 2
}

export enum AgentUserStatus {
  None = 0,
  Normal = 1,
  Banned = 2
}

export enum AgentUserPasswordStatus {
  None = 0,
  Normal = 1,
  Init = 2,
  Reset = 3
}

interface IUserInfoReply {
  id: string
  agentId: string
  username: string
  status: AgentUserStatus
  passwordStatus: AgentUserPasswordStatus
  agentInfo: IAgentInfo
}

interface IAgentInfo {
  id: string
  name: string
  domain: string
  channel: string
  status: AgentStatus
}
